export class InputUtils {
  static onPastePattern(event: ClipboardEvent, allowedPattern: RegExp): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');

    if (allowedPattern.test(pastedText)) {
      event.preventDefault();
    }
  }

  static allowOnlyPattern(event: KeyboardEvent, pattern: RegExp): void {
    const inputChar = event.key;
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
